module.exports = __webpack_public_path__ + "static/media/2018.e3c2e19d.jpg";